export default __webpack_public_path__ + "61e59cbf0eae2216f136f516dacee0e6.jpg";